module.exports = __webpack_public_path__ + "static/img/12-3.8a690fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12-3.jpg
// module id = IfD2
// module chunks = 0